@if (loggedIn()) {
  <router-outlet></router-outlet>
}
@if (!loggedIn() && !loggingIn()) {
  <login-page></login-page>
}
@if (!loggedIn() && loggingIn()) {
  <div style="position: absolute; left: calc(50% - 100px); top: calc(50% - 50px)">
    Logging in ...<i class="fas fa-spinner fa-spin"></i></div>
  }
  @if (!loggedIn() && loggingIn()) {
    <button class="btn cl-btn-micro" style="position: absolute; right: 0; bottom: 0"
      (click)="cleanLocalStorage()">Clean
      Local Storage
    </button>
  }

<!-- castlabs-ui's dark-mode checkbox, app-wide so the login page and /reports follow the stored theme too
     (its labels are in the logged-in side nav). Not .cl-nav-checkbox, so no '.cl-nav-checkbox:checked ~ …'
     side-nav rule can see it. Only the anchor for castlabs-ui's CSS and clThemeSetup(): keyboard and
     screen readers use the side nav's switch, which sits in the nav's tab order (a focusable input here
     came last in the tab order, and focusing it scrolled the page). -->
<input id="cl-mode-dark" type="checkbox" class="app-theme-checkbox" tabindex="-1" aria-hidden="true">
